import 'reflect-metadata';

export const TransPropMetadataKey = Symbol('icc:elementType');

/** If field is an array or union of types, then elementType is required */
export function TransProp(elementType?: Function): PropertyDecorator {
    return (target, propertyKey) => {
        if (elementType) {
            Reflect.defineMetadata(TransPropMetadataKey, elementType, target, propertyKey);
        }
    };
}